// src/sections/Hero.js
import React, { useEffect, useState } from 'react';
import './Hero.css';
import logo from '../assets/logo.png'; // 会社ロゴ
import heroVideo from '../assets/hero-video.mp4'; // ヒーロー動画
import Navigation from '../components/Navigation';

function Hero() {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const footer = document.querySelector('footer');
      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        // フッターが画面に入ったら非表示
        setIsVisible(footerRect.top >= viewportHeight);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // 初期チェック

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {/* 固定ロゴ */}
      <header className={`fixed-header ${!isVisible ? 'hidden' : ''}`}>
        <img 
          src={logo} 
          alt="会社ロゴ" 
          role="button"
          className="fixed-logo"
          onClick={scrollToTop}
          style={{ cursor: 'pointer' }}
        />
      </header>

      {/* 固定ナビゲーション */}
      <nav className={`fixed-navigation ${!isVisible ? 'hidden' : ''}`}>
        <Navigation position="right" />
      </nav>

      {/* ヒーローセクション */}
      <section id="hero" className="hero-section">
        <video className="hero-video" autoPlay loop muted playsInline>
          <source src={heroVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </section>
    </>
  );
}

export default Hero;
